import { useState, useEffect, useRef, useCallback, memo, useMemo } from "react";
import Masonry from "react-masonry-css";
import { ScrollToTop } from "./ScrollToTop";
import { usePageMeta } from "../utils/usePageMeta";

type SortOrder = "newest" | "oldest";

// Totes les imatges de la galeria (ordre cronològic ascendent)
const galleryImages = [
  "20151107_182813.jpg",
  "20151107_182856.jpg",
  "20180113_213049.JPG",
  "20180321_140913.JPG",
  "20180421_195514.JPG",
  "20190804_123839.jpg",
  "20190805_144612.jpg",
  "20190810_154753.jpg",
  "20190810_154954.jpg",
  "20190810_155136.jpg",
  "20190810_223550.jpg",
  "20190810_223604.jpg",
  "20210611_122556.jpg",
  "20210926_194002.jpg",
  "20211001_165621.jpg",
  "20211001_181738.jpg",
  "20220128_181459.jpg",
  "20220128_181617.jpg",
  "20220212_134707.jpg",
  "20220212_134800.jpg",
  "20220218_182520.jpg",
  "20220325_165146.jpg",
  "20220325_165155.jpg",
  "20220326_113305.jpg",
  "20220326_173307.jpg",
  "20220326_173313.jpg",
  "20220427_161833.jpg",
  "20220429_165306.jpg",
  "20220508_201156.jpg",
  "20220910_130539.jpg",
  "20220910_130544.jpg",
  "20220910_131033.jpg",
  "20220910_132651.jpg",
  "20220910_133000.jpg",
  "20220910_133230.jpg",
  "20220910_133317.jpg",
  "20220910_133333.jpg",
  "20220910_133516.jpg",
  "20220910_133543.jpg",
  "20220910_133548.jpg",
  "20220910_133642.jpg",
  "20220910_133731.jpg",
  "20220910_133745.jpg",
  "20220910_133935.jpg",
  "20220910_134002.jpg",
  "20220910_134043.jpg",
  "20220910_134533.jpg",
  "20220910_134544.jpg",
  "20220910_134548.jpg",
  "20220910_135402.jpg",
  "20220910_135544.jpg",
  "20220910_135546.jpg",
  "20220910_135547.jpg",
  "20220910_162717.jpg",
  "20220910_163146.jpg",
  "20220910_163159.jpg",
  "20220910_163420.jpg",
  "20220910_163511.jpg",
  "20220910_163919.jpg",
  "20220910_164003.jpg",
  "20220910_164502.jpg",
  "20220910_164657.jpg",
  "20220910_164732.jpg",
  "20220910_164829.jpg",
  "20220910_164932.jpg",
  "20220910_164951.jpg",
  "20220910_172500-1.jpg",
  "20220910_172500.jpg",
  "20220910_172503.jpg",
  "20220910_172551.jpg",
  "20220910_172557.jpg",
  "20220910_172832.jpg",
  "20220910_172837.jpg",
  "20220910_172845.jpg",
  "20220910_180037.jpg",
  "20221007_151819.jpg",
  "20221028_110022.jpg",
  "20221028_110046.jpg",
  "20221202_165406.jpg",
  "20221209_165125.jpg",
  "20221209_165132.jpg",
  "20221209_165142.jpg",
  "20221209_165148.jpg",
  "20221223_165221.jpg",
  "20221223_165230.jpg",
  "20230111_152016.jpg",
  "20230205_190047.jpg",
  "20230210_182430.jpg",
  "20230224_164923.jpg",
  "20230226_110205.JPG",
  "20230709_203922.jpg",
  "20230812_165815.jpg",
  "20230912_110349.jpg",
  "20230913_112829.jpg",
  "20230916_135533.jpg",
  "20230916_163012.jpg",
  "20230917_180821.jpg",
  "20230929_203724.jpg",
  "20230929_230100.jpg",
  "20230929_230243.jpg",
  "20230929_230302.jpg",
  "20230929_230417.jpg",
  "20231007_164418.jpg",
  "20231007_164441.jpg",
  "20240405_181956.jpg",
  "20240419_181428.jpg",
  "20240510_165939.jpg",
  "20240510_182034.jpg",
  "20240510_182427.jpg",
  "20240521_112803.jpg",
  "20240531_205227.jpg",
  "20240721_114228.jpg",
  "20240721_120014.jpg",
  "20240721_173533.jpg",
  "20240721_173956.jpg",
  "20240721_212526.jpg",
  "20240721_223937.jpg",
  "20240721_223956.jpg",
  "20240721_224035.jpg",
  "20240723_162011.jpg",
  "20240723_162152.jpg",
  "20240723_162432.jpg",
  "20240723_181729.jpg",
  "20240723_211515.jpg",
  "20240724_111319.jpg",
  "20240724_111320.jpg",
  "20240724_131549.jpg",
  "20240725_212600.jpg",
  "20240726_115954.jpg",
  "20240726_120136.jpg",
  "20240726_121518.jpg",
  "20240726_122212.jpg",
  "20240726_122314.jpg",
  "20240727_084823.jpg",
  "20240727_103147.jpg",
  "20240727_205950.jpg",
  "20240727_210003.jpg",
  "20240727_210029.jpg",
  "20240727_210052.jpg",
  "20240727_211359.jpg",
  "20240727_212327.jpg",
  "20240727_212336.jpg",
  "20240727_212425.jpg",
  "20240727_215646.jpg",
  "20240911_184716.jpg",
  "20240916_131038.jpg",
  "20240916_131150.jpg",
  "20240916_131242.jpg",
  "20240916_131535.jpg",
  "20240916_131842.jpg",
  "20240916_132406.jpg",
  "20240916_132418.jpg",
  "20240916_133013.jpg",
  "20240916_133029.jpg",
  "20240916_133741.jpg",
  "20240920_164709.jpg",
  "20240920_193532.jpg",
  "20240920_232015.jpg",
  "20240920_232049.jpg",
  "20240920_232059.jpg",
  "20240921_000830.jpg",
  "20240927_132423.jpg",
  "20240927_132511.jpg",
  "20240927_132535.jpg",
  "20240927_132541.jpg",
  "20240927_132659.jpg",
  "20240927_132721.jpg",
  "20240927_132734.jpg",
  "20240927_133005.jpg",
  "20240927_133032.jpg",
  "20240927_133114.jpg",
  "20240927_133123.jpg",
  "20240927_133131.jpg",
  "20240927_133206.jpg",
  "20240927_133434.jpg",
  "20240927_133738.jpg",
  "20240927_134119.jpg",
  "20240927_134634.jpg",
  "20240927_134921.jpg",
  "20240927_134938.jpg",
  "20240927_135209.jpg",
  "20240927_135856.jpg",
  "20241001_115544.jpg",
  "20241001_115625.jpg",
  "20241001_120019.jpg",
  "20241001_120138.jpg",
  "20241001_120244.jpg",
  "20241001_120253.jpg",
  "20241001_120457.jpg",
  "20241001_121122.jpg",
  "20241001_121131.jpg",
  "20241001_121333.jpg",
  "20241001_121451.jpg",
  "20241001_121504.jpg",
  "20241001_121530.jpg",
  "20241001_121743.jpg",
  "20241001_121756.jpg",
  "20241001_122529.jpg",
  "20241001_130326.jpg",
  "20241001_130457.jpg",
  "20241001_130918.jpg",
  "20241001_131053.jpg",
  "20241001_131503.jpg",
  "20241001_131532.jpg",
  "20241001_131802.jpg",
  "20241001_132133.jpg",
  "20241001_132211.jpg",
  "20241001_132455.jpg",
  "20241001_132616.jpg",
  "20241009_103858.jpg",
  "20241009_103904.jpg",
  "20241009_103913.jpg",
  "20241009_104228.jpg",
  "20241009_104242.jpg",
  "20241009_104341.jpg",
  "20241009_105320.jpg",
  "20241009_105456.jpg",
  "20241009_105839.jpg",
  "20241009_110614.jpg",
  "20241009_110725.jpg",
  "20241009_110834.jpg",
  "20241009_111137.jpg",
  "20241009_111304.jpg",
  "20241009_111537.jpg",
  "20241009_111818.jpg",
  "20241009_112804.jpg",
  "20241009_112834.jpg",
  "20241009_121131.jpg",
  "20241009_121329.jpg",
  "20241009_121422.jpg",
  "20241009_121855.jpg",
  "20241009_124117.jpg",
  "20241009_124141.jpg",
  "20241009_124147.jpg",
  "20241009_124208.jpg",
  "20241009_124240.jpg",
  "20241009_124312.jpg",
  "20241009_124334.jpg",
  "20241009_124403.jpg",
  "20241009_124411.jpg",
  "20241009_124504.jpg",
  "20241009_124522.jpg",
  "20241009_124551.jpg",
  "20241009_124635.jpg",
  "20241009_124650.jpg",
  "20241009_124732.jpg",
  "20241009_124811.jpg",
  "20241009_124821.jpg",
  "20241009_124944.jpg",
  "20241009_125006.jpg",
  "20241009_125020.jpg",
  "20241009_125039.jpg",
  "20241009_125054.jpg",
  "20241009_125111.jpg",
  "20241009_125222.jpg",
  "20241009_125237.jpg",
  "20241009_125245.jpg",
  "20241009_125319.jpg",
  "20241009_125341.jpg",
  "20241009_125407.jpg",
  "20241009_125425.jpg",
  "20241009_125437.jpg",
  "20241009_125524.jpg",
  "20241009_125559.jpg",
  "20241009_125616.jpg",
  "20241009_125624.jpg",
  "20241009_125815.jpg",
  "20241225_200510.jpg",
  "20241225_200524.jpg",
  "20250131_181719.jpg",
  "20250131_182016.jpg",
  "20250214_203454.jpg",
  "20250214_203521.jpg",
  "20250523_201406.jpg",
  "20250627_191106.jpg",
  "20250724_100857.jpg",
  "20250724_134815.jpg",
  "20250724_135021.jpg",
  "20250724_135038.jpg",
  "20250724_135054.jpg",
  "20250724_153424.jpg",
  "20250724_171438.jpg",
  "20250724_171501.jpg",
  "20250724_182824.jpg",
  "20250724_194138.jpg",
  "20250724_194145.jpg",
  "20250727_103949.jpg",
  "20250727_104006.jpg",
  "20250727_181447.jpg",
  "20250728_104537.jpg",
  "20250728_121321.jpg",
  "20250728_121330.jpg",
  "20250728_191318.jpg",
  "20250728_192420.jpg",
  "20250728_192722.jpg",
  "20250729_105259.jpg",
  "20250729_105325.jpg",
  "20250729_105333.jpg",
  "20250729_105346.jpg",
  "20250729_125335.jpg",
  "20250729_134313.jpg",
  "20250729_171942.jpg",
  "20250729_171956.jpg",
  "20250730_165239.jpg",
  "20250919_232507.jpg",
  "20250919_232520.jpg",
  "20251017_165136.jpg",
  "20251017_181527.jpg",
  "20251017_181546.jpg",
  "20251017_181809.jpg",
  "20251022_224712.jpg",
  "20251108_123624.jpg",
  "20260123_130008.jpg",
  "20260123_130209.jpg",
  "20260124_145649.jpg",
  "20260224_121439.jpg",
  "20260224_121504.jpg",
  "20260224_121657.jpg",
  "20260224_121730.jpg",
  "20260224_121825.jpg",
  "20260224_121844.jpg",
  "20260224_122009.jpg",
  "20260224_122050.jpg",
  "20260224_122142.jpg",
  "20260224_122251.jpg",
  "20260224_122325.jpg",
  "20260224_122552.jpg",
  "20260224_122752.jpg",
  "20260224_122835.jpg",
  "20260224_122845.jpg",
  "20260224_123601.jpg",
  "20260224_125104.jpg",
  "20260224_130702.jpg",
  "20260224_130707.jpg",
  "20260224_133804.jpg",
  "20260224_133919.jpg",
  "20260224_133951.jpg",
];

const INITIAL_LOAD = 50;
const LOAD_MORE_COUNT = 50;
const ASPECT_RATIOS = ["4/3", "3/4", "1/1", "16/9", "4/3", "3/4"];

const MONTH_NAMES_CA = [
  "gener", "febrer", "març", "abril", "maig", "juny",
  "juliol", "agost", "setembre", "octubre", "novembre", "desembre",
];

const parseDateFromFilename = (filename: string): Date => {
  const match = filename.match(/^(\d{4})(\d{2})(\d{2})_(\d{2})(\d{2})(\d{2})/);
  if (!match) return new Date(0);
  const [, year, month, day, hour, min, sec] = match;
  return new Date(+year, +month - 1, +day, +hour, +min, +sec);
};

const formatDateFromFilename = (filename: string): string => {
  const match = filename.match(/^(\d{4})(\d{2})(\d{2})_(\d{2})(\d{2})(\d{2})/);
  if (!match) return "";
  const [, year, month, day, hour, min] = match;
  const monthName = MONTH_NAMES_CA[+month - 1];
  return `${+day} ${monthName} ${year} · ${hour}:${min}`;
};

const GalleryImage = memo(({
  image,
  index,
  onOpen,
}: {
  image: string;
  index: number;
  onOpen: (image: string) => void;
}) => {
  const [loadState, setLoadState] = useState<"idle" | "loading" | "loaded" | "error">("idle");
  const [naturalAspectRatio, setNaturalAspectRatio] = useState<string | null>(null);
  const imgRef = useRef<HTMLDivElement>(null);
  const hasStartedLoading = useRef(false);

  const placeholderAspectRatio = ASPECT_RATIOS[index % ASPECT_RATIOS.length];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasStartedLoading.current) {
          hasStartedLoading.current = true;
          setLoadState("loading");
          observer.disconnect();
        }
      },
      { rootMargin: "600px" }
    );
    if (imgRef.current) observer.observe(imgRef.current);
    return () => observer.disconnect();
  }, []);

  const handleLoad = useCallback((e: React.SyntheticEvent<HTMLImageElement>) => {
    const img = e.currentTarget;
    setNaturalAspectRatio(`${img.naturalWidth}/${img.naturalHeight}`);
    setLoadState("loaded");
  }, []);

  const handleError = useCallback(() => setLoadState("error"), []);
  const handleClick = useCallback(() => onOpen(image), [image, onOpen]);

  const currentAspectRatio = naturalAspectRatio || placeholderAspectRatio;

  return (
    <div
      ref={imgRef}
      className="mb-2 break-inside-avoid"
      style={{ contentVisibility: "auto", containIntrinsicSize: "0 200px" }}
    >
      <button
        onClick={handleClick}
        className="relative w-full overflow-hidden rounded-lg group cursor-pointer focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-background"
        style={{ aspectRatio: currentAspectRatio }}
        aria-label={`Veure foto del ${formatDateFromFilename(image)}`}
      >
        <div className="absolute inset-0 bg-muted" />
        {loadState === "loading" && (
          <div className="absolute inset-0 bg-muted animate-pulse" />
        )}
        {(loadState === "loading" || loadState === "loaded") && (
          <img
            src={`/galeria-opt/${image.replace(/\.(jpe?g)$/i, ".webp")}`}
            alt={`Foto del ${formatDateFromFilename(image)}`}
            className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ease-out group-hover:scale-105 ${
              loadState === "loaded" ? "opacity-100" : "opacity-0"
            }`}
            style={{ transitionProperty: "opacity, transform" }}
            loading="lazy"
            decoding="async"
            onLoad={handleLoad}
            onError={handleError}
          />
        )}
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300 pointer-events-none" />
      </button>
    </div>
  );
});

export const Gallery = () => {
  usePageMeta({
    title: "Galeria | Cotx.es",
    description: "Fotos de cotxes que he anat fent al llarg dels anys.",
  });

  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [visibleCount, setVisibleCount] = useState(INITIAL_LOAD);
  const [isLightboxLoaded, setIsLightboxLoaded] = useState(false);
  const [sortOrder, setSortOrder] = useState<SortOrder>("newest");
  const loaderRef = useRef<HTMLDivElement>(null);

  const sortedImages = useMemo(() => {
    return [...galleryImages].sort((a, b) => {
      const diff = parseDateFromFilename(a).getTime() - parseDateFromFilename(b).getTime();
      return sortOrder === "newest" ? -diff : diff;
    });
  }, [sortOrder]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && visibleCount < sortedImages.length) {
          setVisibleCount(prev => Math.min(prev + LOAD_MORE_COUNT, sortedImages.length));
        }
      },
      { rootMargin: "800px" }
    );
    if (loaderRef.current) observer.observe(loaderRef.current);
    return () => observer.disconnect();
  }, [visibleCount, sortedImages.length]);

  const openLightbox = useCallback((image: string) => {
    setSelectedImage(image);
    setIsLightboxLoaded(false);
    document.body.style.overflow = "hidden";
  }, []);

  const closeLightbox = useCallback(() => {
    setSelectedImage(null);
    document.body.style.overflow = "auto";
  }, []);

  const navigateImage = useCallback((direction: "prev" | "next") => {
    if (!selectedImage) return;
    setIsLightboxLoaded(false);
    const currentIndex = sortedImages.indexOf(selectedImage);
    let newIndex;
    if (direction === "prev") {
      newIndex = currentIndex === 0 ? sortedImages.length - 1 : currentIndex - 1;
    } else {
      newIndex = currentIndex === sortedImages.length - 1 ? 0 : currentIndex + 1;
    }
    setSelectedImage(sortedImages[newIndex]);
  }, [selectedImage, sortedImages]);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (!selectedImage) return;
      if (e.key === "Escape") closeLightbox();
      if (e.key === "ArrowLeft") navigateImage("prev");
      if (e.key === "ArrowRight") navigateImage("next");
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [selectedImage, navigateImage, closeLightbox]);

  const handleToggleSort = useCallback(() => {
    setSortOrder(prev => prev === "newest" ? "oldest" : "newest");
    setVisibleCount(INITIAL_LOAD);
  }, []);

  const currentIndex = selectedImage ? sortedImages.indexOf(selectedImage) : -1;

  return (
    <>
      <div className="min-h-screen bg-background">
        <div className="container mx-auto px-4 sm:px-6 py-8 sm:py-12 max-w-7xl">
          {/* Header */}
          <div className="mb-8 flex flex-col sm:flex-row sm:items-end gap-4 sm:gap-0 sm:justify-between">
            <div>
              <h1 className="text-3xl sm:text-4xl font-bold text-foreground">
                Galeria
              </h1>
              <p className="text-muted-foreground mt-2">
                Fotos de cotxes que he fet
              </p>
              <p className="text-sm text-muted-foreground/60 mt-1">
                7 nov. 2015 – 24 feb. 2026 · {galleryImages.length} fotos
              </p>
            </div>

            {/* Sort toggle */}
            <button
              onClick={handleToggleSort}
              className="inline-flex items-center gap-2 px-4 py-2 rounded-lg border border-border bg-background hover:bg-muted transition-colors text-sm font-medium text-foreground self-start sm:self-auto"
              aria-label={sortOrder === "newest" ? "Canviar a ordre de més antigues primer" : "Canviar a ordre de més recents primer"}
            >
              {sortOrder === "newest" ? (
                <>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="M12 5v14M5 12l7 7 7-7" />
                  </svg>
                  Més recents primer
                </>
              ) : (
                <>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="M12 19V5M5 12l7-7 7 7" />
                  </svg>
                  Més antigues primer
                </>
              )}
            </button>
          </div>

          {/* Masonry grid */}
          <Masonry
            breakpointCols={{ default: 5, 1024: 4, 768: 3, 640: 2 }}
            className="flex gap-2 -ml-2"
            columnClassName="pl-2 bg-clip-padding"
          >
            {sortedImages.slice(0, visibleCount).map((image, index) => (
              <GalleryImage
                key={image}
                image={image}
                index={index}
                onOpen={openLightbox}
              />
            ))}
          </Masonry>

          {/* Infinite scroll trigger */}
          {visibleCount < sortedImages.length && (
            <div ref={loaderRef} className="flex flex-col items-center gap-2 py-8">
              <div className="flex items-center gap-2 text-muted-foreground">
                <svg className="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                </svg>
                <span>Carregant més fotos...</span>
              </div>
              <p className="text-sm text-muted-foreground/60">
                {visibleCount} de {sortedImages.length} fotos
              </p>
            </div>
          )}
        </div>
      </div>

      {/* Lightbox */}
      {selectedImage && (
        <div
          className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center animate-in fade-in duration-200"
          onClick={closeLightbox}
        >
          {/* Close */}
          <button
            onClick={closeLightbox}
            className="absolute top-4 right-4 z-10 p-2 text-white/80 hover:text-white transition-colors"
            aria-label="Tancar"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>

          {/* Previous */}
          <button
            onClick={(e) => { e.stopPropagation(); navigateImage("prev"); }}
            className="absolute left-4 top-1/2 -translate-y-1/2 p-2 text-white/80 hover:text-white transition-colors"
            aria-label="Anterior"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="m15 18-6-6 6-6" />
            </svg>
          </button>

          {/* Next */}
          <button
            onClick={(e) => { e.stopPropagation(); navigateImage("next"); }}
            className="absolute right-4 top-1/2 -translate-y-1/2 p-2 text-white/80 hover:text-white transition-colors"
            aria-label="Següent"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="m9 18 6-6-6-6" />
            </svg>
          </button>

          {/* Loading spinner */}
          {!isLightboxLoaded && (
            <div className="absolute inset-0 flex items-center justify-center">
              <svg className="animate-spin h-10 w-10 text-white/50" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
              </svg>
            </div>
          )}

          {/* Image */}
          <img
            src={`/galeria-opt/${selectedImage.replace(/\.(jpe?g)$/i, ".webp")}`}
            alt={`Foto del ${formatDateFromFilename(selectedImage)}`}
            className={`max-h-[85vh] max-w-[90vw] object-contain transition-opacity duration-200 ${
              isLightboxLoaded ? "opacity-100" : "opacity-0"
            }`}
            onClick={(e) => e.stopPropagation()}
            onLoad={() => setIsLightboxLoaded(true)}
          />

          {/* Bottom info: date + counter */}
          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1">
            {formatDateFromFilename(selectedImage) && (
              <p className="text-white/90 text-sm font-medium">
                {formatDateFromFilename(selectedImage)}
              </p>
            )}
            <p className="text-white/50 text-xs">
              {currentIndex + 1} / {sortedImages.length}
            </p>
          </div>
        </div>
      )}

      <ScrollToTop />
    </>
  );
};

export default Gallery;
